import { Button, Col, Modal, Row } from "antd";
import React, { useContext } from "react";
import "../../../assets/css/commonVessels.css";
import { AppContext } from "../../../context/AppContext";
import { useLocation } from "react-router-dom";
import { ClockCircleOutlined } from "@ant-design/icons";
const InvalidModal = (props) => {
    let title = "";
    let modalContent = "";
    let modalButton = "";
    let link = "";
  
    const { open = true, setOpen = () => {}, closable = false } = props;
    const location = useLocation();
    const [appProperties] = useContext(AppContext);
    let authObj = appProperties.authorizeObj;
    let leftAuth = authObj?.left?.auth?.authorized;
    let rightAuth = authObj?.right?.auth?.authorized;
    if (!leftAuth || !rightAuth) {
      title = appProperties?.authTitle;
      modalContent = appProperties?.authContent;
      modalButton = appProperties?.authButton;
      link = `/channels/textsms/${authObj?.right?.service_name}`;
      appProperties?.controller?.getUrlParamsForRedirection(true, appProperties).then(function (redirectionUrlFromApp) {
        if (redirectionUrlFromApp) {
          link += "?" + redirectionUrlFromApp;
        } else {
          link += location.search;
        }
      });
    }
  
    function DoAuthorization() {
      if (!leftAuth) {
        const leftAuthWindow = window.open(appProperties.authLink, "Popup", "width=700,height=700,left=350,top=100");
        const receiveMessage = (event) => {
          if (event !== undefined && event.data !== undefined) {
            let data = event.data;
            if (typeof event.data === "string") {
              data = JSON.parse?.(event.data);
            }
            if (data !== undefined && data?.data?.integId !== undefined && data?.data?.userId !== undefined) {
              const urlParams = new URLSearchParams(window.location.search);
              urlParams.set("userId", data.data.userId);
              window.history.replaceState(null, "", "?" + urlParams.toString());
              window.location.reload();
            } else if (data !== undefined && data?.data?.osyncId !== undefined) {
              window.location.reload();
            }
          }
        };
        try {
          window.addEventListener("message", receiveMessage);
          return () => {
            leftAuthWindow.close();
            window.removeEventListener("message", receiveMessage);
          };
        } catch (error) {}
      } else {
        window.open(link);
      }
    }
    return (
      <>
        <Modal width={700} open={open} footer={null} closable={closable} onCancel={() => setOpen(false)} centered>
          <Row>
            <Col xs={5} md={4} lg={4} xl={4}>
              <ClockCircleOutlined className="clockIconInModal" />
            </Col>
            <Col xs={18} md={12} lg={12} xl={12} className="activateAuthorizeModal">
              <p className="modalTitle text-dark">{title}</p>
              <p className="modalDescription text-secondary">{modalContent}</p>
            </Col>
            <Col xs={3} md={2} lg={2} xl={2}></Col>
            <Col xs={18} md={12} lg={12} xl={12} className="ModalBtn">
              <Button onClick={DoAuthorization} className="fs-6 activateBtn" type="primary" size="middle">
                <span style={{ fontSize: "1rem" }}>{modalButton}</span>
              </Button>
            </Col>
          </Row>
        </Modal>
      </>
    );
};

export default InvalidModal;